import 'semantic-ui-css/semantic.min.css';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'mobx-react';

import App from './App';
import AuthStore from './services/auth';
import CustomerStore from './pages/customer/store';
import SaleStore from './pages/sale/SaleStore';


const stores = {
  AuthStore,
  CustomerStore,
  SaleStore,
};


ReactDOM.render(
  <Provider {...stores} children={App}><App /></Provider>, document.getElementById('root')
);